<h1 class="h5">My Account</h1>

@if (!loading) {
  <div class="row g-1 g-lg-3">
    <div class="d-flex mb-3">
      <div class="card shadow border-0 w-50">
        <div class="card-header fw-bold">
          <div class="card-title mb-0">Company Informations</div>
        </div>
        <div class="card-body">
          <form [formGroup]="form.company" (ngSubmit)="onSubmitCompany()">
            <div class="row g-2">
              <div class="col-lg-6">
                <label for="company-status" class="form-label small fw-bold">Status</label>
                <select [ngModel]="$safeNavigationMigration(connectedUser?.companyStatus)" [ngModelOptions]="{standalone: true}"
                  class="form-select form-select-sm form-select form-select-sm-sm" id="company-status" disabled>
                  @for (status of companyStatusList; track status) {
                    <option [value]="status">
                      {{ ('companyStatus.' + status) | translate }}
                    </option>
                  }
                </select>
              </div>
              <div class="col-lg-6">
                <label for="company-name" class="form-label small fw-bold">Company name</label>
                <input [ngModel]="$safeNavigationMigration(connectedUser?.companyName)" [ngModelOptions]="{standalone: true}"
                  type="text" class="form-control form-control-sm" id="company-name" disabled>
              </div>
              <div class="col-lg-6">
                <label for="registration-number" class="form-label small fw-bold">Company registration number</label>
                <input [ngModel]="$safeNavigationMigration(connectedUser?.companyRegistrationNumber)" [ngModelOptions]="{standalone: true}"
                  type="text" class="form-control form-control-sm" id="registration-number" disabled>
              </div>
              <div class="col-lg-6">
                <label for="vat-number" class="form-label small fw-bold">Company VAT number</label>
                <input [ngModel]="$safeNavigationMigration(connectedUser?.companyVatNumber)" [ngModelOptions]="{standalone: true}"
                  type="text" class="form-control form-control-sm" id="vat-number" disabled>
              </div>
              <div class="col-12">
                <label for="langs" class="form-label small fw-bold">Language</label>
                <div class="d-flex">
                  <app-dropdown-select [multiple]="true" formControlName="langs" placeholder="🌍 All languages" id="langs"
                    class="w-100">
                    @for (lang of langs; track lang) {
                      <app-dropdown-select-option [value]="lang.id">
                        <img [ngSrc]="langService.getFlag(lang)" [alt]="lang.name" width="24" height="24"
                          class="me-1 country-flag">{{ lang.name }}
                        </app-dropdown-select-option>
                      }
                    </app-dropdown-select>
                  </div>
                </div>
                <div class="col-12">
                  <label for="company-address" class="form-label small fw-bold">Address</label>
                  <textarea formControlName="address" class="form-control form-control-sm" id="company-address"></textarea>
                </div>
                <div class="col-lg-6">
                  <label for="zip-code" class="form-label small fw-bold">Zip code</label>
                  <input formControlName="zipCode" type="text" class="form-control form-control-sm" id="zip-code">
                </div>
                <div class="col-lg-6">
                  <label for="city" class="form-label small fw-bold">City</label>
                  <input formControlName="city" type="text" class="form-control form-control-sm" id="city">
                </div>
                <div class="col-lg-6">
                  <label for="state" class="form-label small fw-bold">State</label>
                  <input formControlName="state" type="text" class="form-control form-control-sm" id="state">
                </div>
                <div class="col-lg-6">
                  <label for="country" class="form-label small fw-bold">Country</label>
                  <select class="form-select form-select-sm" formControlName="country" id="country">
                    @for (country of countries; track country) {
                      <option [ngValue]="country.isoCode">{{ country.name }}</option>
                    }
                  </select>
                </div>
                <div class="col-12 col-lg-6">
                  <label for="phone-number" class="form-label small fw-bold">Phone number</label>
                  <input formControlName="phoneNumber" type="text" class="form-control form-control-sm" id="phone-number">
                </div>
                <div class="col-12 col-lg-6">
                  <label for="email" class="form-label small fw-bold">Email address</label>
                  <input formControlName="email" type="email" class="form-control form-control-sm" id="email">
                </div>
                <div class="col-12 text-end">
                  <button [disabled]="submittingCompany || form.company.invalid" [appElementLoader]="submittingCompany"
                    class="btn btn-sm btn-primary fw-bold" type="submit">SAVE
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="card shadow border-0 w-50 ms-3">
          <div class="card-header fw-bold">
            <div class="card-title mb-0">Contact Informations</div>
          </div>
          <div class="card-body">
            <form [formGroup]="form.mainContact" (ngSubmit)="onSubmitContact()">
              <div class="row g-2">
                <div class="col-lg-4">
                  <label for="civility" class="form-label small fw-bold">Civility</label>
                  <select class="form-select form-select-sm" formControlName="civility" id="civility">
                    @for (civility of civilityList; track civility) {
                      <option
                        [value]="civility">{{ 'civility.' + civility | translate }}
                      </option>
                    }
                  </select>
                </div>
                <div class="col-lg-4">
                  <label for="contact-firstname" class="form-label small fw-bold">First Name</label>
                  <input formControlName="firstname" type="text" class="form-control form-control-sm"
                    id="contact-firstname">
                </div>
                <div class="col-lg-4">
                  <label for="contact-lastname" class="form-label small fw-bold">Last Name</label>
                  <input formControlName="lastname" type="text" class="form-control form-control-sm"
                    id="contact-lastname">
                </div>
                <div class="col-12">
                  <label for="contact-email" class="form-label small fw-bold">Email address</label>
                  <input formControlName="email" type="email" class="form-control form-control-sm" id="contact-email">
                </div>
                <div class="col-12">
                  <label for="contact-phone" class="form-label small fw-bold">Mobile number</label>
                  <input formControlName="phoneNumber" type="text" class="form-control form-control-sm"
                    id="contact-phone">
                </div>
                <div class="col-6">
                  <label for="contact-telegram" class="form-label small fw-bold">Telegram</label>
                  <input formControlName="telegram" type="text" class="form-control form-control-sm"
                    id="contact-telegram">
                </div>
                <div class="col-6">
                  <label for="contact-teams" class="form-label small fw-bold">Teams</label>
                  <input formControlName="teams" type="text" class="form-control form-control-sm" id="contact-teams">
                </div>
                <div class="col-12">
                  <label for="contact-nickname" class="form-label small fw-bold">Nickname</label>
                  <input formControlName="nickname" type="text" class="form-control form-control-sm"
                    id="contact-nickname">
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col">
                      <label class="form-label small fw-bold">Document</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-file-earmark"></i></span>
                        <input type="file" class="form-control" (change)="imageUpload($event)">
                      </div>
                    </div>
                    @if (connectedUser?.getMainContact()?.document?.url) {
                      <div class="col-auto pt-4">
                        <a [href]="$safeNavigationMigration(connectedUser?.getMainContact()?.document?.url)" download>
                          <i class="bi bi-download h3"></i>
                        </a>
                      </div>
                    }
                  </div>
                </div>
                <div class="col-12 text-end">
                  <button [disabled]="submittingMainContact || form.mainContact.invalid"
                    [appElementLoader]="submittingMainContact"
                    class="btn btn-sm btn-primary fw-bold" type="submit">SAVE
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="d-flex">
        <div class="card shadow border-0 w-50">
          <div class="card-header fw-bold">
            <div class="card-title mb-0">Payment Informations</div>
          </div>
          <div class="card-body">
            <form [formGroup]="form.payment" (ngSubmit)="onSubmitPayment()">
              <div class="row g-2">
                <div class="col-12">
                  <label for="account-holder" class="form-label small fw-bold">Account holder</label>
                  <input formControlName="accountHolder" type="text" class="form-control form-control-sm"
                    id="account-holder">
                </div>
                <div class="col-12">
                  <label for="bank-name" class="form-label small fw-bold">Bank name</label>
                  <input formControlName="bankName" type="text" class="form-control form-control-sm" id="bank-name">
                </div>
                <div class="col-12">
                  <label for="bank-address" class="form-label small fw-bold">Bank address</label>
                  <textarea formControlName="bankAddress" class="form-control form-control-sm"
                  id="bank-address"></textarea>
                </div>
                <div class="col-12">
                  <label for="iban" class="form-label small fw-bold">IBAN / Account number</label>
                  <input formControlName="iban" type="text" class="form-control form-control-sm" id="iban">
                </div>
                <div class="col-12">
                  <label for="swift" class="form-label small fw-bold">SWIFT / BIC</label>
                  <input formControlName="swift" type="text" class="form-control form-control-sm" id="swift">
                </div>
                <div class="col-12">
                  <label for="routing-number" class="form-label small fw-bold">Routing number / ABA</label>
                  <input formControlName="routingNumber" type="text" class="form-control form-control-sm"
                    id="routing-number">
                </div>
                <div class="col-12 text-end">
                  <button [disabled]="submittingPayment || form.payment.invalid" [appElementLoader]="submittingPayment"
                    class="btn btn-sm btn-primary fw-bold" type="submit">SAVE
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="card shadow border-0 w-50 ms-3">
          <div class="card-header fw-bold">
            <div class="card-title mb-0">Compliance Documents</div>
          </div>
          <div class="card-body">
            <div class="row g-2">
              @for (type of documentTypeList; track type; let last = $last) {
                <div class="col-12">
                  <div class="d-flex align-items-center">
                    <i [ngClass]="getDocumentTypeIcon(type)" class="bi me-2 fs-2 text-muted"></i>
                    <div>
                      <p class="mb-0 lh-1">
                        <strong>{{ ('complianceDocumentType.' + type) | translate }}</strong><br>
                        @if (!connectedUser?.documents?.[type]?.document) {
                          <small class="text-danger">No document
                          saved</small>
                        }
                        @if (connectedUser?.documents?.[type]?.document) {
                          @if (connectedUser?.documents?.[type]?.status === 'pending') {
                            <small class="text-warning">Awaiting
                            approval</small>
                          }
                          @if (connectedUser?.documents?.[type]?.status === 'refused') {
                            <small
                            class="text-danger">Refused</small>
                          }
                          @if (connectedUser?.documents?.[type]?.status === 'approved') {
                            <small class="text-success">Approved</small>
                          }
                        }
                      </p>
                    </div>
                    <div class="ms-3">
                      @if (connectedUser?.documents?.[type]?.document?.url) {
                        <a
                          [href]="$safeNavigationMigration(connectedUser?.documents?.[type]?.document?.url)" download><i
                        class="bi h5 fs-2 bi-download"></i></a>
                      }
                      @if (!connectedUser?.documents?.[type]?.document?.url) {
                        <i
                        class="bi bi-download h5 fs-2 opacity-25"></i>
                      }
                    </div>
                  </div>
                  <input (change)="documentUpload($event, type)" type="file" class="form-control form-control-sm mt-1">
                </div>
                @if (!last) {
                  <div class="col-12">
                    <hr class="opacity-25">
                  </div>
                }
              }
              <!-- Save Button -->
              <div class="col-12 text-end">
                <button (click)="submitDocuments()"
                  [disabled]="submittingDocuments" [appElementLoader]="submittingDocuments"
                  class="btn btn-sm btn-primary fw-bold" type="button">SAVE
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
